import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.min.css';

const propTypes = {
  className: PropTypes.string,
  containerStyle: PropTypes.object,
  height: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  scale: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
};

const defaultProps = {
  className: undefined,
  containerStyle: {},
};

class ReactCropper extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      isLoading: true,
    };
  }

  componentDidMount() {
    this.cropper = new Cropper(this.domRef, {
      dragMode: 'move',
      aspectRatio: 1,
      autoCropArea: 1,
      restore: false,
      guides: false,
      center: false,
      highlight: false,
      cropBoxMovable: false,
      cropBoxResizable: false,
      preview: null,
      zoomOnTouch: false,
      zoomOnWheel: false,
      ready: () => {
        this.setState({ isLoading: false });
      },
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.isLoading && this.props.scale !== nextProps.scale) {
      this.scaleImage(nextProps.scale);
    }
  }

  componentWillUnmount() {
    this.cropper.destroy();
  }

  getCroppedCanvas(...args) {
    return this.cropper.getCroppedCanvas(...args);
  }

  scaleImage(scale) {
    const {
      width,
      height,
    } = this.cropper.getCropBoxData();
    const xRatio = width / this.domRef.naturalWidth;
    const yRatio = height / this.domRef.naturalHeight;
    const zoom = Math.max(xRatio, yRatio) * scale;
    this.cropper.zoomTo(zoom);
  }

  render() {
    const {
      className,
      containerStyle,
      image,
      height,
      width,
    } = this.props;

    return (
      <div
        className={className}
        style={
          Object.assign({}, containerStyle, {
            opacity: this.state.isLoading ? 0 : 1,
          })
        }
      >
        <div
          className="img-container"
          style={{
            height,
            width,
          }}
        >
          <img
            alt=""
            ref={(ref) => {
              this.domRef = ref;
            }}
            src={image}
            style={{ maxWidth: '100%' }}
          />
        </div>
      </div>
    );
  }
}

ReactCropper.propTypes = propTypes;
ReactCropper.defaultProps = defaultProps;

export default ReactCropper;
